import React from 'react';

const PayrollHeader = ({ navigate, canAddPayroll, canEditPayroll, canDeletePayroll, handleAdd }) => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="card shadow-sm border-0">
                    <div className="card-body py-4">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <div className="d-flex align-items-center">
                                    <div className="btn-group me-3" role="group">
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => navigate('/dashboard')}
                                            title="Go to Dashboard"
                                        >
                                            <i className="bi bi-speedometer2"></i>
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            onClick={() => navigate('/Menu')}
                                            title="Go to Menu"
                                        >
                                            <i className="bi bi-menu-button"></i>
                                        </button>
                                    </div>
                                    <div>
                                        <h2 className="h4 mb-1 fw-bold text-dark">
                                            <i className="bi bi-calculator me-2 text-primary"></i>
                                            Payroll Management
                                            {!canAddPayroll && !canEditPayroll && !canDeletePayroll && (
                                                <span className="badge bg-warning ms-2">View Only</span>
                                            )}
                                        </h2>
                                        <p className="text-muted mb-0">
                                            Manage payroll periods and processing
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 text-end">
                                <div className="d-flex justify-content-end align-items-center">
                                    <button
                                        className="btn btn-outline-secondary me-2"
                                        onClick={() => navigate('/admin-panel')}
                                    >
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Back to Admin Panel
                                    </button>
                                    {canAddPayroll && (
                                        <button
                                            className="btn btn-primary text-white"
                                            onClick={handleAdd}
                                        >
                                            <i className="bi bi-plus-circle me-2"></i>
                                            Add Payroll Period
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollHeader;